import KendoTreeList from '../KendoTreeList'
import KendoTreeListColumn from '../KendoTreeListColumn'

let KendoTreeListInstaller = class {
    static install(Vue) {
        Vue.component(KendoTreeList.name, KendoTreeList)
        Vue.component(KendoTreeListColumn.name, KendoTreeListColumn)
    }
}

export default KendoTreeListInstaller

// Automatic installation if Vue has been added to the global scope.
if (typeof window !== 'undefined' && window.Vue && window.Vue.use) {
    window.Vue.use(KendoTreeListInstaller)
}


// WEBPACK FOOTER //
// ./packages/kendo-treelist-vue-wrapper/src/kendo-treelist-installer/index.js